<div class="plans-container" id="plans">
  <div class="plans-cotent">
    <div class="plans-section">
      <span class="emphasis section-header">
        {{ 'mainPageComponent.plansBanner.pricingPlans' | translate }}
      </span>
      <h2 class="title-md">
        {{ 'mainPageComponent.plansBanner.header' | translate }}
      </h2>
    </div>
    <app-plans-cards [plans]="plans()" />
  </div>
</div>
